import DraggableResizableVue from 'draggable-resizable-vue3'
import { tokens } from 'maska'
import { vMaska } from 'maska/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import Toast, { PluginOptions } from 'vue-toastification'

import App from './App.vue'
import { vuetify } from './plugins/vuetify'
import router from './router.js'

// @ts-ignore
import 'vue-toastification/dist/index.css'
import 'vuetify/styles'
import './style.scss'
import '@mdi/font/css/materialdesignicons.css'

// Разрешаем кириллицу во всех масках темы, сохраняя поддержку латиницы.
tokens['@'] = { pattern: /[a-zA-Zа-яА-ЯёЁ]/ }
tokens['*'] = { pattern: /[a-zA-Zа-яА-ЯёЁ0-9]/ }

const app = createApp(App)

const options: PluginOptions = {
  // You can set your default options here
}

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.use(Toast, options)
app.use(DraggableResizableVue)
app.directive('maska', vMaska)

app.mount('#app')
